// extracted by mini-css-extract-plugin
export var alignDiscLeft = "q_q6 d_fp d_bG d_dv";
export var alignLeft = "q_qh d_fp d_bG d_dv";
export var alignDiscCenter = "q_q7 d_fq d_bD d_dw";
export var alignCenter = "q_bP d_fq d_bD d_dw";
export var alignDiscRight = "q_q8 d_fr d_bH d_dx";
export var alignRight = "q_qj d_fr d_bH d_dx";
export var footerContainer = "q_q9 d_dW d_bW";
export var footerContainerFull = "q_rb d_dT d_bW";
export var footerHeader = "q_kf d_kf";
export var footerTextWrapper = "q_rc d_w";
export var footerDisclaimerWrapper = "q_km d_km d_ck";
export var badgeWrapper = "q_rd d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "q_rf d_bz d_bJ d_bN d_bL";
export var wide = "q_rg d_cy";
export var right = "q_rh d_bK";
export var line = "q_fk d_fl d_cv";
export var badgeDisclaimer = "q_rj d_bC d_bP d_bJ";
export var badgeContainer = "q_rk d_bz d_bH d_bP";
export var badge = "q_rl";
export var padding = "q_rm d_c7";
export var end = "q_rn d_bH";
export var linkWrapper = "q_rp d_dB";
export var link = "q_mC d_dB";
export var colWrapper = "q_rq d_cx";
export var consent = "q_f d_f d_bC d_bP";
export var disclaimer = "q_rr d_bz d_bJ";
export var media = "q_rs d_bx d_dy";
export var itemRight = "q_rt";
export var itemLeft = "q_rv";
export var itemCenter = "q_rw";
export var exceptionWeight = "q_rx x_sH";